import { Injectable } from '@angular/core';
import { FuseMockApiService, FuseMockApiUtils } from '@fuse/lib/mock-api';
import { cloneDeep } from 'lodash-es';
@Injectable({
    providedIn: 'root'
})
export class SectionsMockApi
{
    private readonly _sections: any[];
    constructor(private _fuseMockApiService: FuseMockApiService)
    {
        this.registerHandlers();
    }

    /**
    * Register Mock API handlers
    */
    registerHandlers(): void
    {
        this._fuseMockApiService
            .onGet('api/sections')
            .reply(() => {

            // Clone the data to preserve the originals
            const sections = cloneDeep(this._sections);
           

            // Do some stuff with your data

            // Return
            return [200, {
                section: sections,
            }];
        })

        // Navigation - PUT
        this._fuseMockApiService
            .onPut('api/sections')
            .reply(({request}) => {

            // Save the new navigation item
            const newsection = cloneDeep(request.body.sectionitem);
            newsection.id = FuseMockApiUtils.guid();
            this._sections.unshift(newsection);

            // Return
            return [200, newsection];
        });

    }
}